define('AwaLabs.ScrollToLink.Module', [
    'jQuery',
    'underscore',
    'ItemRelations.Correlated.Collection'
], function AwaLabsScrollToLinkModule(
    jQuery,
    _,
    ItemRelationsCorrelatedCollection
) {
    'use strict';

    ItemRelationsCorrelatedCollection.prototype.fetchItems = _.wrap(ItemRelationsCorrelatedCollection.prototype.fetchItems, function fetchItemsFn(fn) {
        return fn.apply(this).then(function thenFn(res) {
            if (res.items[0] && res.items[0].correlateditems_detail.length) {
                jQuery('.recommendations-link').removeClass('hidden');
            }
        });
    });
});
